import {services} from '../../../api';
import {store} from '../../../redux/store';
import {
  homeTabsFail,
  homeTabsLoading,
  setHomeTabs,
  setLatestNews,
} from './reducer';
import {getNews} from '../tabNews/actions';
import {SpecialityType} from '../../../interfaces/api/auth/login';
import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';

/**
 * this function to get home tabs with recommendations
 *
 * @return {HomeTabsData | null} result of home tabs and recommendations
 */
export const getHomeTabs = async (): Promise<void> => {
  try {
    store.dispatch(homeTabsLoading());
    const res = await services.home.getHomeTabsFilters();
    const homeNews = await getNews({pageSize: 4});
    store.dispatch(setLatestNews(homeNews?.data || []));
    store.dispatch(setHomeTabs(res?.content?.data || []));
  } catch (error: any) {
    store.dispatch(homeTabsFail());
  }
};

/**
 * this function to get specialities list
 *
 * @return {SpecialityType[]} specialities list
 */
export const getSpecialities = async (
  professionId: number,
): Promise<SpecialityType[]> => {
  try {
    startLoading();
    const res = await services.home.getSpecialities(professionId);
    return res?.content?.data;
  } catch (error: any) {
    if (process.env.REACT_APP_DEBUG === 'true') {
    }
    return [];
  } finally {
    finishLoading();
  }
};
